<template>  
  <div class="evento-wrapper" ref="wrapperRef">

    <!-- Fondo -->
    <img 
      :src="require('@/assets/F1.jpg')" 
      alt="Fondo" 
      class="fondo-textura" 
    />

    <!-- Ramita decorativa -->
    <img 
      src="@/assets/ramita.avif" 
      alt="Decoración" 
      class="ramita-fondo-visual" 
    />

    <!-- TARJETA -->
    <div ref="ceremoniaRef" class="tarjeta-evento derecha reveal">

      <p ref="tituloRef" class="titulo-evento">
        Mesa de Regalos
      </p>

      <div class="separator-holder reveal">
        <img 
          :src="require('@/assets/separadorr.png')" 
          alt="Separador" 
          class="separador-img" 
        />
      </div>

      <p ref="lugarRef" class="lugar">
        Tu presencia es nuestro mejor<br>
        regalo, pero si quieres tener un<br>
        detalle con nosotros te damos la<br>
        sugerencia de:
      </p>

      <!-- SOBRE -->
      <div class="sobre-box reveal">
        <img 
          src="@/assets/sobr.png" 
          alt="Sobre" 
          class="icono-sobre" 
        />
      </div>

      <!-- TEXTO -->
      <p class="hora reveal">
        Lluvia de Sobres
      </p>

    </div>

    <!-- DRESSCODE -->
    <div ref="dressCodeRef" class="dresscode-box reveal">

      <p class="dresscode-title">
        Código de vestimenta
      </p>

      <div class="separator-holder mini reveal">
        <img 
          :src="require('@/assets/separadorr.png')" 
          alt="Separador" 
          class="separador-img" 
        />
      </div>

      <p class="dresscode-text">
        El blanco es un color hermoso, 
        pero en esta ocasión es exclusivo 
        para la Novia.
        <br><br>
        Evitar colores estampados.
      </p>

      <!-- 🔥 PALETA (Quitamos clases de reveal de CSS para que solo mande GSAP) -->
      <div class="paleta-box">
        <img 
          ref="paletaRef"
          :src="require('@/assets/paleta.png')" 
          alt="Paleta de colores" 
          class="paleta-img" 
        />
      </div>

    </div>

  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'

export default {
  name: 'EventoDoble',

  setup() {
    const wrapperRef = ref(null)
    const ceremoniaRef = ref(null)
    const tituloRef = ref(null)
    const lugarRef = ref(null)
    const dressCodeRef = ref(null)
    const paletaRef = ref(null)

    onMounted(() => {
      // 1. Intersection Observer para elementos con clase .reveal
      const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
          if(entry.isIntersecting){
            entry.target.classList.add('visible')
          }
        })
      }, { threshold: 0.15 })

      document.querySelectorAll('.reveal').forEach(el=>{
        observer.observe(el)
      })

      /* 🔥 GSAP PALETA - Corregido */
      // Usamos un timeline para asegurar el orden
  
      gsap.fromTo(
        paletaRef.value, 
        { 
          opacity: 0, 
          y: 60, 
          scale: 0.8, 
          rotate: -5 
        },
        { 
          opacity: 1, 
          y: 0, 
          scale: 1, 
          rotate: 0, 
          duration: 1.2, 
          ease: 'back.out(1.7)',
          onComplete: () => {
            // Animación infinita de flotado una vez que aparece
            gsap.to(paletaRef.value, {
              y: '-=10',
              duration: 2,
              repeat: -1,
              yoyo: true,
              ease: 'sine.inOut'
            })
          }
        }
      )
    })

    return {
      wrapperRef,
      ceremoniaRef,
      tituloRef,
      lugarRef,
      dressCodeRef,
      paletaRef
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700&family=Poppins:wght@300;400;500&display=swap');

.evento-wrapper {
  position: relative;
  width: 100%;
  min-height: 100vh;
  padding: 120px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 1;
  overflow-x: hidden; /* Evita scroll horizontal por animaciones */
}

.fondo-textura {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}

.ramita-fondo-visual {
  position: absolute;
  top: -120px;
  left: 0;
  width: 100%;
  opacity: .05;
  z-index: 1;
  pointer-events: none;
}

.tarjeta-evento {
  position: relative;
  z-index: 5;
  width: 100%;
  max-width: 390px;
  padding: 50px 28px;
  text-align: center;
  border-radius: 40px;
  background: rgba(255,255,255,.72);
  backdrop-filter: blur(4px);
  box-shadow: 0 10px 40px rgba(0,0,0,.10);
  margin-bottom: 40px;
}

.titulo-evento {
  font-family: 'Playfair Display', serif;
  font-size: 38px;
  color: #b08a5a;
  margin-bottom: 10px;
}

.lugar {
  font-family: 'Playfair Display', serif;
  font-size: 22px;
  line-height: 1.6;
  color: #6f6660;
  margin-top: 18px;
}

.sobre-box {
  margin-top: 24px;
  display: flex;
  justify-content: center;
}

.icono-sobre {
  width: 100px;
  height: auto;
  filter: drop-shadow(0 8px 16px rgba(0,0,0,.12));
}

.hora {
  margin-top: 18px;
  font-family: 'Playfair Display', serif;
  font-size: 32px;
  color: #b08a5a;
}

/* ========= DRESSCODE ========= */
.dresscode-box {
  position: relative;
  z-index: 5;
  width: 100%;
  max-width: 340px;
  padding: 34px 24px;
  text-align: center;
  border-radius: 30px;
  background: rgba(255,255,255,.72);
  backdrop-filter: blur(4px);
  box-shadow: 0 10px 30px rgba(0,0,0,.08);
}

.dresscode-title {
  font-family: 'Playfair Display', serif;
  font-size: 30px;
  color: #b08a5a;
}

.dresscode-text {
  margin-top: 10px;
  font-family: 'Playfair Display', serif;
  font-size: 18px;
  line-height: 1.6;
  color: #6f6660;
}

/* 🔥 PALETA CORREGIDA */
.paleta-box {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  min-height: 150px; /* Espacio reservado para que no salte al cargar */
}

.paleta-img {
  width: 220px;
  height: auto;
  display: block;
  /* Eliminamos las transiciones de CSS para que no choquen con GSAP */
  filter: drop-shadow(0 10px 18px rgba(0,0,0,.15));
}

.separator-holder {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}

.separador-img {
  width: 80%;
}

/* ========= ANIMACIONES CSS ========= */
.reveal {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 1.2s ease, transform 1.2s ease;
}

.reveal.visible {
  opacity: 1;
  transform: translateY(0);
}

@media(max-width:768px){
  .titulo-evento { font-size: 32px; }
  .paleta-img { width: 180px; }
}
</style>